import log from 'loglevel';
import remote from 'loglevel-plugin-remote';
import { Component } from 'react';

const customJSON = (log) => ({
	message: log.message,
	level: log.level.label,
	stacktrace: log.stacktrace,
	timestamp: log.timestamp,
	userAgent: navigator.userAgent,
	location: window.location.href,
});

const remoteLoggingSettings = {
	url: window.API_URL + 'system/logs/client',
	method: 'POST',
	headers: {},
	token: sessionStorage.getItem('access_token') ?? localStorage.getItem('access_token'),
	onUnauthorized: (failedToken) => {
		remote.setToken(sessionStorage.getItem('access_token') ?? localStorage.getItem('access_token'));
	},
	timeout: 0,
	interval: 1000,
	level: 'error',
	backoff: {
		multiplier: 2,
		jitter: 0.1,
		limit: 30000,
	},
	capacity: 500,
	stacktrace: {
		levels: ['trace', 'warn', 'error'],
		depth: 10,
		excess: 0,
	},
	timestamp: () => new Date().toISOString(),
	format: customJSON,
};

remote.apply(log, remoteLoggingSettings);

log.enableAll();
window.console = log;

class ErrorHandler extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	componentDidCatch(error, info) {
		// log the error to our server with loglevel
		log.error({ error, info });
	}

	render() {
		//  if (this.state.hasError) {
		//   // You can render any custom fallback UI
		//   return <h1>Something went wrong, please refresh page.</h1>;
		//  }

		return this.props.children;
	}
}

export default ErrorHandler;
